import { useEffect } from 'react';
import type { MarketplaceStatusSnapshot } from './marketplaceNavLogic';
import { resolveNavTourSteps, type NavTourTrack } from './resolveNavTourSteps';

export function resolveNavTourTrack(
  status: Pick<MarketplaceStatusSnapshot, 'canManage'> & { ready: boolean },
): NavTourTrack | null {
  if (!status.ready) return null;
  return status.canManage ? 'host' : 'member';
}

export function marketplaceNavTourStepIndexAfterEnable(
  track: NavTourTrack,
  status: MarketplaceStatusSnapshot,
  currentStepId: string | undefined,
  opts?: { includeTheme?: boolean },
): number | null {
  if (currentStepId !== 'marketplace-enable' || !status.enabled) return null;
  const nextSteps = resolveNavTourSteps(track, status, opts);
  const idx = nextSteps.findIndex((s) => s.id === 'marketplace');
  return idx >= 0 ? idx : null;
}

export function usePollMarketplaceStatusDuringEnableStep(
  active: boolean,
  stepId: string | undefined,
  enabled: boolean,
  reload: () => Promise<void>,
  intervalMs = 1500,
): void {
  useEffect(() => {
    if (!active || stepId !== 'marketplace-enable' || enabled) return;
    const id = window.setInterval(() => {
      void reload();
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [active, stepId, enabled, reload, intervalMs]);
}
